import "../sass/app.scss";

import CollapseMobileMenu from "./modules/CollapseMobileMenu";
import AjaxHandler from "./modules/AjaxHandler";
import ThreeSlidesTextCarousel from "./modules/ThreeSlidesTextCarousel";
import SwiperCarousel from './modules/SwiperCarousel';
import DownloadPopup from './modules/DownloadPopup';
import SocialShare from './modules/SocialShare';
import ShowcaseAccordion from './modules/ShowcaseAccordion';
import ShowcaseDisplay from './modules/ShowcaseDisplay';
import LoginMenuSwitcher from './modules/LoginMenuSwitcher';


const collapseMobileMenu = new CollapseMobileMenu();
const ajaxHandler = new AjaxHandler();
const threeSlidesTextCarosel = new ThreeSlidesTextCarousel();
const swiperCarousel = new SwiperCarousel();
const downloadPopup = new DownloadPopup();
const socialShare = new SocialShare();
const showcaseAccordion = new ShowcaseAccordion();
const showcaseDisplay = new ShowcaseDisplay();
const loginMenuSwitcher = new LoginMenuSwitcher();

/*
function show_animated_logo() {
    var newImg = document.createElement("img");
    newImg.setAttribute("id", "animatedIcon");
    newImg.setAttribute("src", "https://new.scaffolddesign.com.au/wp-content/uploads/2023/09/Scaffold-Design-animated-icon.gif");
    document.body.insertBefore(newImg, oldImg);
}

window.onload = function() {
    var hasSeenLogo = document.cookie.indexOf('seen_logo') >= 0;
    var oldImg = document.getElementsByClassName("custom-logo")[0];

    if (!hasSeenLogo) {
        show_animated_logo();
        var date = new Date();
        date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
        document.cookie = 'seen_logo=true; expires=' + date.toUTCString() + '; path=/';
    } 

    oldImg.style.display = "inline-block";
};
*/


/* Animated Logo Responsive with Seen_logo Cookie */
function show_animated_logo(oldImg) {
    window.newImg = document.createElement("img");
    window.newImg.setAttribute("id", "animatedIcon");
    window.newImg.setAttribute("src", "https://new.scaffolddesign.com.au/wp-content/uploads/2023/09/Scaffold-Design-animated-icon.gif");

    // Set position to absolute and adjust top and left values.
    window.newImg.style.position = 'absolute';
    window.newImg.style.top = '0px';
    window.newImg.style.left = '0px';

  	// Insert it into body 
  	oldImg.parentNode.appendChild(window.newImg);
    
  	// Set initial width
  	updateImageWidth(window.newImg, oldImg);
}

function updateImageWidth(newLogo, oldLogo) {
  // Set width to be 23% of the original logo.
  var oldLogoWidth = oldLogo.getBoundingClientRect().width; 
  newLogo.style.width= (oldLogoWidth * 0.23) + 'px';
}

window.onload = function() {
	var hasSeenLogo = document.cookie.indexOf('seen_logo') >= 0;
	var oldImgs = document.getElementsByClassName("custom-logo"); 

	if(oldImgs.length>0 && !hasSeenLogo){
		var oldLogoContainer=oldImgs[0].parentNode;

		// Make sure logo container is relative so absolute positioning works properly.
		oldLogoContainer.style.position="relative";

		show_animated_logo(oldImgs[0]);

		window.addEventListener('resize', function() {
			var animatedIcon = document.getElementById('animatedIcon');
			if(animatedIcon){
				updateImageWidth(animatedIcon, oldImgs[0]);
			}
    	});

    	var date = new Date();
    	date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
    	document.cookie = 'seen_logo=true; expires=' + date.toUTCString() + '; path=/';

    	setTimeout(function(){
    		window.newImg.style.display="none";
    	},5000); // Assuming the animation lasts for five seconds. Adjust as needed.
    	
   }
};




/* Custom Design template Page */
/*
$('.category-btn').on('click', function(e) {
    e.preventDefault();
 
    $('.category-btn').removeClass('active');
    $(this).addClass('active');
 
    var categorySlug = $(this).data('category');
    var searchTerm = $('#search-input').val();
 
    $.ajax({
       url: ajax_object.ajax_url,
       type: "POST",
       data: {
          action: "my_custom_filter",
          category_slug : categorySlug,
          search_term : searchTerm,
       },
       success:function(data) {
          // Clear out the current posts on your page...
          $('#results-container').empty();
          
          // Parse the JSON response and add each post to your page...
          var posts = JSON.parse(data);
          
          $.each(posts, function(index, post) {
              $('#results-container').append(`
                  <div class="project">
                      <h2>${post.title}</h2>
                  </div>
              `);
           });
        },
        error:function(errorThrown){
           console.log(errorThrown);
        }
   });
});
*/